export enum PaymentTermsType {
	EOM = 0,
	NET = 10,
	FOM = 20,
	MFI = 30
}